import { useState, type ReactNode } from 'react'

interface MarkerTooltipProps {
  /** Línea principal (p.ej. tipo de componente). */
  title: string
  /** Línea secundaria opcional (p.ej. nombre del componente). */
  subtitle?: string | null
  /** Solo hover: no alterna con click (para markers cuyo click ya abre otra UI). */
  hoverOnly?: boolean
  children: ReactNode
}

/**
 * Tooltip para hijos de `AdvancedMarker`: muestra un rótulo flotante sobre el
 * glifo al pasar el mouse y lo alterna con click/tap (soporte táctil). Se
 * renderiza dentro del propio marker (HTML), así que no necesita `InfoWindow`
 * ni estado a nivel de mapa.
 */
export function MarkerTooltip({ title, subtitle, hoverOnly, children }: MarkerTooltipProps) {
  const [open, setOpen] = useState(false)

  return (
    <div
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onClick={hoverOnly ? undefined : () => setOpen((o) => !o)}
    >
      {open && (
        <div
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 7px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(30, 41, 59, 0.95)',
            color: 'white',
            padding: '4px 9px',
            borderRadius: '6px',
            fontSize: '11px',
            lineHeight: 1.35,
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            zIndex: 20,
            boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
            textAlign: 'center',
          }}
        >
          <div style={{ fontWeight: 700 }}>{title}</div>
          {subtitle && <div style={{ opacity: 0.85 }}>{subtitle}</div>}
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '5px solid transparent',
              borderRight: '5px solid transparent',
              borderTop: '5px solid rgba(30, 41, 59, 0.95)',
            }}
          />
        </div>
      )}
      {children}
    </div>
  )
}
